module.exports = __webpack_public_path__ + "img/charging-GERMANY-en.7c2715d7.png";